<div class="notification-container">
  <span class="notification-message" [style.cursor]="this.data.url ? 'pointer' : 'inherit'" (click)="openLink()">
    {{ message }}
  </span>
</div>
